module.exports = __webpack_public_path__ + "img/11.54ceb221.jpg";